<template>
  <div class="assign-main">
    <div v-if="showHeader" class="assign-header">
      <div class="label-container">
        <div class="label-title">{{ tripIsBeingEdited ? 'Edit' : 'Assign' }}</div>
        <div class="label-seperator">:</div>
        <div class="label-content">{{title}}</div>
        <img @click="closeClicked" src="https://dsmlib.logistics.systems/Icons/Cancel.png" style="width: 25px; height: 25px; background-color: white; border-radius: 50%; cursor: pointer;" alt="">
      </div>
    </div>

    <div class="assign-content">
      <div class="white-container">
        <div>
          <Dropdown ref="primemover" :items="primeMovers" itemKey="Keyname" placeholder="Prime Mover" :selectedObject.sync="selectedPrimeMover" :errorMessage.sync="primeMoverError" :isRequired="true" :isDisabled="primeMoverDisabled"/>
          <Validator title="Availability" :value="availabilityValue" :valid="availabilityValid"/>
          <Validator title="Road Tax" :value="roadTaxValue" :valid="roadTaxValid"/>
          <Validator title="Inspection" :value="inspectionValue" :valid="inspectionValid"/>
          <Validator title="Permit" :value="permitValue" :valid="permitValid"/>
        </div>
        <div style="margin-top: 5px;">
          <Dropdown :items="trailers" itemKey="Keyname" placeholder="Trailer No" :selectedObject.sync="selectedTrailerNo" :errorMessage.sync="trailerNoError" :isDisabled="trailerNoDisabled"/>
        </div>
      </div>
      <div class="white-container">
        <div>
          <Dropdown ref="driver" :items="drivers" itemKey="Keyname" placeholder="Driver" :selectedObject.sync="selectedDriver" :errorMessage.sync="driverError" :isRequired="true" :isDisabled="driverDisabled"/>
          <Validator title="Driver License" :value="driverLicenseValue" :valid="driverLicenseValid"/>
          <Validator title="Badge License" :value="badgeDriverLicenseValue" :valid="badgeDriverLicenseValid"/>
          <Validator title="Port Pass" :value="portPassDriverValue" :valid="portPassDriverValid"/>
        </div>
        <div style="marginTop: 5px;">
          <Dropdown ref="attendant" :items="attendants" itemKey="Keyname" placeholder="Attendant" :selectedObject.sync="selectedAttendant" :errorMessage.sync="attendantError" :isDisabled="attendantDisabled"/>
          <!-- <Validator title="Attendant License" :value="attendantLicenseValue" :valid="attendantLicenseValid"/>
          <Validator title="Badge License" :value="badgeAttendantLicenseValue" :valid="badgeAttendantLicenseValid"/>
          <Validator title="Port Pass" :value="portPassAttendantValue" :valid="portPassAttendantValid"/> -->
        </div>

      </div>
      <div class="white-container">
        <div class="content-label">
          <div class="content">
            <Dropdown :search.sync="freeTextConsignmentNo" placeholder="Consignment #" ref="consignment" :items="consignments" itemKey="Consignment #" :selectedObject.sync="selectedConsignmentNo" :isRequired="true" :isDisabled="consignmentNoDisabled"/>
            <Input placeholder="Container #" :inputValue.sync="freeTextContainerNo" :isContainer="true" @focusChanged="contNoLostFocus" :isDisabled="containerDisabled"/>
            <div class="content-container">
              <div class="content-container-row">
                <div class="content-container-title">SzTyp</div>
                <div class="content-container-separator">:</div>
                <div class="content-container-value">{{szType}}</div>
              </div>
              <div class="content-container-row">
                <div class="content-container-title">Hdg</div>
                <div class="content-container-separator">:</div>
                <div class="content-container-value">{{hdg}}</div>
              </div>
              <div class="content-container-row">
                <div class="content-container-title">Del</div>
                <div class="content-container-separator">:</div>
                <div class="content-container-value">{{del}}</div>
              </div>
              <!-- <span>SzTyp : <span>{{szType}}</span></span><br>
              <span>Hdg : <span>{{hdg}}</span></span><br>
              <span>Del : <span>{{del}}</span></span> -->
            </div>
            <Input style="marginTop:5px;" placeholder="Seal #" :inputValue.sync="inputSealNo" :errorMessage.sync="sealNoError" :isDisabled="sealNoDisabled"/>
          </div>
          <div class="content">
            <Dropdown :search.sync="freeTextB2BConsignmentNo" placeholder="B2B Consignment #" :items="b2bConsignmentNo" itemKey="Consignment #" :selectedObject.sync="selectedB2BConsignmentNo" :errorMessage.sync="b2bConsignmentNoError" :isDisabled="b2bConsignmentNoDisabled"/>
            <Input placeholder="Container #" :inputValue.sync="freeTextB2BContainerNo" :isContainer="true" @focusChanged="contNoLostFocus" :isDisabled="b2bContainerDisabled"/>
            <div class="content-container">
              <div class="content-container-row">
                <div class="content-container-title">SzTyp</div>
                <div class="content-container-separator">:</div>
                <div class="content-container-value">{{szTypeB2b}}</div>
              </div>
              <div class="content-container-row">
                <div class="content-container-title">Hdg</div>
                <div class="content-container-separator">:</div>
                <div class="content-container-value">{{hdgB2b}}</div>
              </div>
              <div class="content-container-row">
                <div class="content-container-title">Del</div>
                <div class="content-container-separator">:</div>
                <div class="content-container-value">{{delB2b}}</div>
              </div>
            </div>
            <Input style="marginTop:5px;" placeholder="B2B Seal #" :inputValue.sync="inputSealNoB2b" :errorMessage.sync="sealNoB2bError" :isDisabled="sealNoB2bDisabled"/>

          </div>
        </div>
        <div class="movement-container"> 
          <Dropdown ref="movement" :items="movements" itemKey="Keyname" placeholder="Movement" :selectedObject.sync="selectedMovement" :errorMessage.sync="movementError" :isRequired="true" @selected="movementDropdownObjectSelected" :isDisabled="movementDisabled"/>
          <Tooltip position="left" :overlay="true" :xOffset="-0" :yOffset="-200" :minWidth="710" :maxWidth="710">
            <template v-slot:tooltip>
              <img src="https://dsmapi.logistics.systems/diagrams/movementType.png" alt="Movement type diagram" style="display:block; width:700px; max-width:700px; height:auto;"/>
            </template>
          </Tooltip>
        </div>
        <Dropdown ref="from" :items="destinations" itemKey="Keyname" placeholder="From" :selectedObject.sync="selectedFrom" :errorMessage.sync="fromError" :isRequired="!nonRev" :isDisabled="fromDisabled"/>
        <Dropdown ref="to" :items="destinations" itemKey="Keyname" placeholder="To" :selectedObject.sync="selectedTo" :errorMessage.sync="toError" :isRequired="!nonRev" :isDisabled="toDisabled"/>
        <div style="display:flex; justify-content:space-between;">
          <DateTimePicker ref="etd" :value.sync="selectedETD" :showTime="true" placeholder="ETD" :errorMessage.sync="ETDError" :isDisabled="ETDDisabled" :isRequired="true"/>
          <DateTimePicker ref="eta" :value.sync="selectedETA" :showTime="true" placeholder="ETA" :errorMessage.sync="ETAError" :isDisabled="ETADisabled"/>
          <div></div>
        </div>
        <RemarksBox style="height: 100px;" placeholder="Remarks" :text.sync="inputRemarks" :isDisabled="remarksDisabled"/>
      </div>
    </div>

    <div class="assign-footer">
      <div class="message-container" :style="{backgroundColor : disabledSave ? 'lightyellow' : ''}">
      <div v-if="!fieldsFulfilled">
        <div v-for="(item,index) in errorMessageToDisplay" :key="index">
          <a @click="requiredClicked(item['field'])">{{item['errorMessage']}}</a>
        </div>
      </div>
      <div v-else>
        <div v-for="(item, index) in postAssignMessage" :key="index">
          <span style="fontWeight:bold;"><div v-html="item['status']"></div><div v-html="item['recordguid']"></div></span>
        </div>
      </div>
      </div>
      <div class="buttons-container">
        <button :disabled="disabledSave" @click="saveClicked">
          <img src="https://dsmapi.logistics.systems/dsm6gIcons/Save.png" alt='Save'/>Save
        </button>
        <!-- <button @click="closeClicked" style="visibility:hidden;"><img src="https://dsmapi.logistics.systems/dsm6gIcons/Cancel.png" alt="Cancel"/>Cancel</button> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
  },
  computed : {
    tripIsBeingEdited: function() {
      return Boolean(this.assignData["PM"] && this.assignData["Driver"]); // if both PM and Driver are not null, assume that the user is editing a trip
    },
    submittedConsignmentNo: function() {
      if (this.selectedConsignmentNo && this.selectedConsignmentNo['Consignment #'] === this.freeTextConsignmentNo) {
        return this.selectedConsignmentNo['Consignment #']; // if user selected from the dropdown, return consignment # from the dropdown item
      }
      return this.freeTextConsignmentNo; // else, return what the user entered
    },
    submittedB2BConsignmentNo: function() {
      if (this.selectedB2BConsignmentNo && this.selectedB2BConsignmentNo['Consignment #'] === this.freeTextB2BConsignmentNo) {
        return this.selectedB2BConsignmentNo['Consignment #']; // if user selected from the dropdown, return consignment # from the dropdown item
      }
      return this.freeTextB2BConsignmentNo; // else, return what the user entered
    },
  },
  data: function() {
    return {
      //#region API RETURN FOR DROPDOWNS
      b2bConsignmentNo : [],
      b2bContainerNo : [],
      primeMovers : [],
      trailers : [],
      drivers : [],
      attendants: [],
      consignments : [],
      containers : [],
      movements : [],
      destinations : [],
      //#endregion

      //#region reactives
      title : '',
      szType : '',
      hdg : '',
      del : '',
      szTypeB2b : '',
      hdgB2b : '',
      delB2b : '',
      messageContainer : null,


      freeTextConsignmentNo : '',
      freeTextContainerNo : '',
      freeTextB2BConsignmentNo : '',
      freeTextB2BContainerNo : '',
      selectedB2BConsignmentNo : null,
      b2bConsignmentNoError : '',
      b2bConsignmentNoDisabled: false,
      selectedB2BContainerNo : null,
      b2bContainerDisabled : false,
      b2bContainerNoError : '',
      selectedConsignmentNo : null,
      consignmentNoDisabled: false,
      selectedContainerNo : null,
      containerDisabled : false,
      inputSealNo : '',
      sealNoError: '',
      sealNoDisabled: false,
      inputSealNoB2b : '',
      sealNoB2bError : '',
      sealNoB2bDisabled : '',
      inputRemarks : '',
      remarksDisabled: false,

      selectedPrimeMover : null,
      primeMoverError: '',
      primeMoverDisabled: false,
      availabilityValue : '',
      availabilityValid : false,
      roadTaxValue : '',
      roadTaxValid : false,
      inspectionValue : '',
      inspectionValid : false,
      permitValue : '',
      permitValid : false,
      selectedTrailerNo : null,

      trailerNoError : '',
      trailerNoDisabled: false,

      selectedDriver : null,
      driverError : '',
      driverDisabled: false,
      driverLicenseValue : '',
      driverLicenseValid : false,
      badgeDriverLicenseValue : '',
      badgeDriverLicenseValid : false,
      portPassDriverValue : '',
      portPassDriverValid : false,

      selectedAttendant : null,
      attendantError : '',
      attendantDisabled: false,
      attendantLicenseValue : '',
      attendantLicenseValid : false,
      badgeAttendantLicenseValue : '',
      badgeAttendantLicenseValid : false,
      portPassAttendantValue : '',
      portPassAttendantValid : false,

      selectedMovement : null,
      movementError : '',
      movementDisabled: false,
      selectedFrom : null,
      fromError : '',
      fromDisabled: false,
      selectedTo : null,
      toError : '',
      toDisabled: false,
      selectedETD : null,
      ETDError : '',
      ETDDisabled: false,
      selectedETA : null,
      ETAError : '',
      ETADisabled: false,

      //#endregion

      //#region Footer Message Box
      errorMessageToDisplay : [],
      postAssignMessage: [],
      fieldsFulfilled : false,
      disabledSave : false,
      //#endregion

    }
  },
  props: {
    showHeader: {type: Boolean, default: true},
    show: {type: Boolean, default : false},
    assignData : {type: Object, default : function() { return null; }},
    subShow : {type : Boolean, default : false},
    // this data should take in keys such as Consignment #, Container #, Sz/Ty, Hdg, Del, Type, Bucket, Remarks, FullData.. optional
    nonRev: {type: Boolean, defalt : false}
  },
  methods: {
    requiredClicked : function (field) {
      this.$refs[field].setFocus();
    },
    switchMessageContainerColor : function () { // set background to red, text colour to white
      this.messageContainer.style.setProperty('background-color', '#eb8787');
      this.messageContainer.style.setProperty('color', 'white');
    },
    movementDropdownObjectSelected: function(selectedMovement) { // code was moved here from the selectedMovement watcher property
      if (!selectedMovement) {
        this.selectedFrom = null;
        this.selectedTo = null;
        this.selectedETD = null;
        this.selectedETA = null;
        return;
      }

      if (!this.destinations) {
        return;
      }

      this.selectedFrom = (
        selectedMovement['DepArea'] == '' ?
        null :
        (this.destinations.find(i => {return i['Destination Code'] == selectedMovement['DepCode']}) || null)
      );
      this.selectedTo = (
        selectedMovement['DestArea'] == '' ?
        null :
        (this.destinations.find(i => {return i['Destination Code'] == selectedMovement['DestCode']}) || null)
      );

      this.selectedETD = new Date();
      let minutesToAdd = selectedMovement['TripDurationMin'];
      this.selectedETA = (minutesToAdd == 0 || minutesToAdd == '') ? new Date() : new Date(new Date().setTime(new Date().getTime() + (minutesToAdd * 60 * 1000)));
    },
    assignNewTrip : async function () {
      let dataToPost = {
        "VehicleCode": this.selectedPrimeMover['VehicleCode'],
        "Staff_No": this.selectedDriver['Staff_No'],
        "MovementType": this.selectedMovement['MovementType'],
        "JIDate": this.selectedETD ? this.selectedETD.formatString('yyyy-MM-dd') : new Date().formatString('yyyy-MM-dd'),
        "SealNo": this.inputSealNo,
        "DepartureCode": this.selectedFrom ? this.selectedFrom['Destination Code'] : '',
        "DestinationCode": this.selectedTo ? this.selectedTo['Destination Code'] : '',
        "EstDepartTime": this.selectedETD ? this.selectedETD.formatString('yyyy-MM-dd HH:mm') : "",
        "EstArriveTime": this.selectedETA ? this.selectedETA.formatString('yyyy-MM-dd HH:mm'): "",
        "TrCode": !this.selectedTrailerNo ? '' : this.selectedTrailerNo['VehicleCode'],
        "Remarks": this.inputRemarks,
        "DateUpdated": "",
        "DeviceID": "",
        "MobileNo": "",
        "GPSLatitude": "",
        "GPSLongitude": "",
        "Attendant" : !this.selectedAttendant ? '' : this.selectedAttendant['Staff_No'],
        "B2BSealNo" : this.inputSealNoB2b,
        // free text enabled section
        "CN": this.submittedConsignmentNo,
        "ContainerNo": this.freeTextContainerNo,
        "B2BCN" : this.submittedB2BConsignmentNo,
        "B2BContainerNo" : this.freeTextB2BContainerNo,
      };

      let hmscndeltypevspmsl = this.selectedMovement['HMSCNDelTypevsPMSL'];
      let deliverytype = this.selectedMovement['DeliveryType'];
      let sideloader = this.selectedPrimeMover['Sideloader'];


      if (hmscndeltypevspmsl == '1' && ((deliverytype == 'SL' && sideloader == '0') || deliverytype != 'SL' && sideloader == '1')) {
        let respond = await this.$showAlert('warning', `Delivery type advised in consignment is ${deliverytype}. PM assigned is a ${(sideloader == '1') ? 'SideLoader' : 'Trailer'}.`, 'Proceed to assign?', [{color: 'lightgreen', text: 'Ok' }, {color: 'lightgrey', text : 'Cancel'}]);

        if (respond == 'Cancel') {
          return;
        }
      }
      this.$fullscreenLoading('Assigning Trip')
      let result = await this.$apiCallV2('/VehicleTracker/HMSAssignTrip', dataToPost, null, {message : `{{errorMessage}}`});
      if (Array.isArray(result)) {
        if (result[0]['Results'] === 0 || result[0]['Results'] === "0") {
          this.disableFields();
          this.disabledSave = true;
          this.postAssignMessage.push({
            status : 'Successfully assign trip.',
            recordguid : ``
          })
          this.$emit('tripAssigned', true);
        } else {
          this.postAssignMessage.push({
            status : `Trip assignment failed`,
            recordguid : `Message : ${result[0]['ErrMsg']}`
          })
          this.switchMessageContainerColor();
        }
      }
      this.$fullscreenLoading('')
    },
    editTrip: async function(continueedit = "0", continueedit2 = "0") {
      const requestBody = {
        "action": "E",
        "vehicle": this.selectedPrimeMover["VehicleCode"],
        "trailerno": this.selectedTrailerNo ? this.selectedTrailerNo["VehicleNo"] : "",
        "trailercode": this.selectedTrailerNo ? this.selectedTrailerNo["VehicleCode"] : "",

        "driver": this.selectedDriver["Staff_No"],
        "attendant": this.selectedAttendant ? this.selectedAttendant["Staff_No"] : "",

        "jobno": this.assignData["Job #"],
        "jobtype": this.assignData["Job Type"],
        "cn": this.submittedConsignmentNo, // when editing a trip, the consignment # dropdown will be disabled, since there will only ever be 1 item in it and users aren't supposed to change it
        "containerno": this.freeTextContainerNo.trim(), 
        "oldcontainerno": this.assignData["Container #"],
        "editcontno": this.freeTextContainerNo.trim().toLowerCase() !== this.assignData["Container #"].trim().toLowerCase() ? "1" : "0",
        "sealno": this.inputSealNo,
        "journeyguid": this.assignData["Journey GUID"],
        "jino": this.assignData["JINo"],
        "jiseqno": this.assignData["JISeqNo"],
        "cnlastupstatus": this.assignData["LastUpStatus"],
        "cnb2b": this.submittedB2BConsignmentNo,
        "b2bcontainerno": this.freeTextB2BContainerNo,
        "oldb2bcontainerno": this.assignData["B2B Container #"],
        "editb2bcontno": this.freeTextB2BContainerNo.trim().toLowerCase() !== this.assignData["B2B Container #"].trim().toLowerCase() ? "1" : "0",

        "movementtype": this.selectedMovement["MovementType"],
        "movementtypecaption": this.selectedMovement["MovementType"], // send the same value for "movementtype" and "movementtypecaption"
        "editmvt": this.selectedMovement["MovementType"].trim().toLowerCase() !== this.assignData["Movement"].trim().toLowerCase() ? "1" : "0",

        "departurecode": this.selectedFrom["Destination Code"],
        "destinationcode": this.selectedTo["Destination Code"],

        "estdeparture": this.selectedETD ? this.selectedETD.formatString("yyyy-MM-dd HH:mm") : "",
        "estarrival": this.selectedETA ? this.selectedETA.formatString("yyyy-MM-dd HH:mm") : "",

        "remarks": this.inputRemarks,
        "team": "", // API will get from database directly, leave blank for now

        "finishdate": this.assignData["_tripHasBeenCompleted"] ? "1" : "0",
        "continueedit": continueedit, // sometimes, the API will return a question (e.g. Trip is already completed, are you sure you wish to edit?), will need to prompt the user in these cases
        "continueedit2": continueedit2, // API can ask up to 2 questions, send "1" if user wishes to proceed, cancel the edit if user does not wish to proceed
        "anscnls": "1", // hard code as "1"
      };

      this.$fullscreenLoading("Editing Trip");
      const response = await this.$apiCallV2("/VehicleSchedule/HMSUpdateTrip", requestBody);

      if (!Array.isArray(response)) { // API is expected to return results in the form of an array with only one element
        this.postAssignMessage.push({ // sometimes the ErrMsg has a newline character in there (or some other forbidden character),
          status : "Trip edit failed", // which makes it unable to be parsed as JSON or an array
          recordguid : `An unknown error occurred. ${response}`, // success messages SHOULDN'T have this issue, so just interpret these cases as an error
        });
        this.switchMessageContainerColor();

        this.$fullscreenLoading();
        return;
      }

      switch (response[0]["Results"]) {
        case 0: case "0":
          this.disableFields();
          this.disabledSave = true;
          this.postAssignMessage.push({
            status : 'Successfully editted trip.',
            recordguid : '',
          });
          this.$emit('tripAssigned', true);
          break;

        case 1: case "1":
          this.postAssignMessage.push({
            status : "Trip edit failed",
            recordguid : `Message : ${response[0]['ErrMsg']}`
          });
          this.switchMessageContainerColor();
          break;

        case 2: case "2": // API returned a warning message
          const userProceed = await this.$showAlert( // ask the user if they still wish to proceed
            'warning',
            'Warning',
            response[0]["ErrMsg"],
            [
              { text: 'Yes' },
              { text: 'No', color: 'lightgray' },
            ]
          );

          if (userProceed === "Yes") { // if the user wishes to proceed despite the warning
            this.editTrip("1", continueedit); // recursive call to editTrip, set continueedit of subsequent call to "1"
          } // continueedit2 will depend on continueedit of current call
          break;

        default:
          if (process.env['NODE_ENV'] == 'development') {
            console.error("[AssignV3] Unhandled result code in editTrip method", `Result: ${response[0]["Results"]}`);
            console.trace();
          }
          break;
      }
      this.$fullscreenLoading();
    },
    saveClicked : async function () {
      await this.$sleep(50); // sleep for 0.05s, so that ETD and ETA values get properly populated
      this.fieldsFulfilled = false;
      this.errorMessageToDisplay = [];
      this.postAssignMessage = [];
      this.messageContainer.style.setProperty('background-color', 'white');
      this.messageContainer.style.setProperty('color', 'black');

      //#region Check Required
      if (!this.selectedPrimeMover) {
        this.errorMessageToDisplay.push({
          field: 'primemover',
          errorMessage: 'Prime Mover is required!'
        });
      }
      if (!this.selectedDriver) {
        this.errorMessageToDisplay.push({
          field : 'driver',
          errorMessage : 'Driver is Required'
        });
      }
      if (!this.selectedConsignmentNo && this.freeTextConsignmentNo === '') {
        this.errorMessageToDisplay.push({
          field: 'consignment',
          errorMessage : 'Consignment No is required'
        });
      }
      if (!this.selectedMovement) {
        this.errorMessageToDisplay.push({
          field : 'movement',
          errorMessage : 'Movement Type is Required'
        });
      }
      if (!this.nonRev && !this.selectedFrom) {
        this.errorMessageToDisplay.push({
          field : 'from',
          errorMessage : 'Departure is Required'
        });
      }
      if (!this.nonRev && !this.selectedTo) {
        this.errorMessageToDisplay.push({
          field : 'to',
          errorMessage : 'Destination is Required'
        });
      }
      if (!this.selectedETD) {
        this.errorMessageToDisplay.push({
          field : 'etd',
          errorMessage : 'ETD is Required'
        });
      }
      //#endregion
      if (this.errorMessageToDisplay.length > 0) {
        this.fieldsFulfilled = false;
        return;
      }

      this.fieldsFulfilled = true;
      if (this.tripIsBeingEdited) { // edit existing trip
        this.editTrip("0", "0");
      } else { // assign new trip
        this.assignNewTrip();
      }
    },
    closeClicked : function() {
      this.$emit('update:show', false)
      this.$emit('update:subShow', false)
    },
    getB2bConsignmentNo : async function (data) {
      if (!data || Object.keys(data).length === 0) {
        this.b2bConsignmentNo = [];
        return;
      }

      if (this.tripIsBeingEdited) { // if user is editing a trip, B2B details are already sent by the GetHMSTripDetails endpoint
        const b2bDetails = [{ //might not be able to get the consignment details from the GetHMSConsignmentsForB2B endpoint
          "Consignment #": data["B2B"], // because the trip may already be halfway completed by the driver/operator
          "Container #": data["B2B Container #"],
          "SzType": data["B2B Sz/Ty"],
          "Handling Type": data["B2B Hdg"],
          "Delivery Type": data["B2B Del"],
          "Seal #": data["B2B Seal #"],
        }];

        this.b2bConsignmentNo = b2bDetails;
        this.b2bContainerNo = b2bDetails;
        return;
      }

      let b2bCnData = await this.$apiCallV2(`/VehicleTracker/GetHMSConsignmentsForB2B?cnno=${data['Consignment #']}`);
      if (b2bCnData.length > 0 && b2bCnData) {
        b2bCnData = this.$jsonNullToStringV2(b2bCnData)
        b2bCnData = this.$deepTrimJsonV3(b2bCnData);
        this.b2bConsignmentNo = b2bCnData;
        this.b2bContainerNo = b2bCnData;
      }
    },
    getJobListing : async function (data) {
      if (!data || Object.keys(data).length === 0) {
        this.consignments = [];
        return;
      }

      let consignmentData = [];
      if (data['Type'] == 'rfc') { // component called from VehicleTracking page via the "Assign Collection" button on the map
        consignmentData = await this.$apiCallV2(`/VehicleTracker/GetHMSRadiocallCollection`);
        if (consignmentData.length > 0 && consignmentData) {
          consignmentData = this.$deepTrimJsonV3(consignmentData);
          consignmentData = this.$jsonNullToStringV2(consignmentData);

          consignmentData.forEach(c => {
            c['Consignment #'] = c['ConsignmentNo'];
            c['Container #'] = c['ContainerNo'];
            c['Sz/Ty'] = `${c['ContSize']}${c['ContType']}`;
            c['Hdg'] = c['HandlingType'];
            c['Del'] = c['DeliveryType'];
          })
        }
      } else if (data["Bucket"]) { // component called from VehicleTracking page via the TableBox button (the one on the bottom)
        consignmentData = await this.$apiCallV2(`/VehicleTracker/GetHMSJobListing?bucket=${data['Bucket']}`);
        if (consignmentData.length > 0 && consignmentData) {
          consignmentData = this.$jsonNullToStringV2(consignmentData);
          consignmentData = this.$deepTrimJsonV3(consignmentData);
        }
      } else { // component called via QuickFind (Find Consignment Note) from VehicleSchedule page OR component is in edit mode
        consignmentData = [data];
      }
      this.consignments = consignmentData;
      this.containers = consignmentData;
    },
    getMovements : async function (data) {
      if (!data || Object.keys(data).length === 0) {
        this.movements = [];
        return;
      }

      if (this.nonRev) {
        let movementData = await this.$apiCallV2("/Master/GetListMaster", {
          masterfile: "NONREVMVT",
        });

        if (!movementData || movementData.length === 0) {
          this.movements = [];
          return;
        }

        movementData = this.$jsonNullToStringV2(movementData);
        movementData = this.$deepTrimJsonV3(movementData);

        this.movements = movementData.map(i => {
          i['Keyname'] = `${i['MovementTypeDesc']} (${i['MovementType']})`;
          return i;
        });

        return;
      }

      let APIURL = `/VehicleTracker/GetMovementType?cnno=${data['Consignment #']}`;
      switch (this.title) {
        case "Delivery":
        case "Staging Delivery":
        case "Stg - Int Diversion 1":
        case "Stg - Int Diversion 2":
          APIURL += "&delcol=D";
          break;

        case "Pending Collection":
        case "Collection":
        case "Staging Collection":
          APIURL += "&delcol=C";
          break;
      }
      if (this.tripIsBeingEdited) {
        APIURL += `&tripaction=E&editmvttype=${this.assignData["Movement"]}`;
      }

      let movementData = await this.$apiCallV2(APIURL);
      if (!movementData || movementData.length === 0) {
        this.movements = [];
        return;
      }

      movementData = this.$jsonNullToStringV2(movementData);
      movementData = this.$deepTrimJsonV3(movementData);
      this.movements = movementData.map(i => {
        i['Keyname'] = `${i['MovementTypeDesc']} (${i['MovementType']})`;
        return i;
      });
    },
    getPrimeMovers : async function () {
      let primeMoversData = await this.$apiCallV2(`/VehicleTracker/GetVehicleListByCategory?vehcat=PM&available=${this.tripIsBeingEdited ? "A" : "1"}`);
      if (primeMoversData.length > 0 && primeMoversData) {
        primeMoversData = this.$jsonNullToStringV2(primeMoversData)
        primeMoversData = this.$deepTrimJsonV3(primeMoversData);

        let primeMoverArr = primeMoversData.map(i => {
          i['Keyname'] = `${i['VehicleNo']} (${i['orivehicleno'] || i['VehicleCode']})` // read orivehicleno, if that doesn't exist then fallback to VehicleCode
          return i;
        })
        this.primeMovers = primeMoverArr;
      }
    },
    getTrailers : async function () {
      let trailersData = await this.$apiCallV2(`/VehicleTracker/GetVehicleListByCategory?vehcat=TR&available=${this.tripIsBeingEdited ? "A" : "1"}`);
      if (trailersData.length > 0 && trailersData) {
        trailersData = this.$jsonNullToStringV2(trailersData);
        trailersData = this.$deepTrimJsonV3(trailersData);
        let trailerArr = trailersData.map(i => {
          i['Keyname'] = `${i['VehicleNo']} (${i['VehicleCode']}) (${i['VehicleLength']})`;
          return i;
        })
        this.trailers = trailerArr;
      }
    },
    getDrivers : async function () {
      let driversData = await this.$apiCallV2(`/VehicleTracker/GetEmployeeListByDepartment`);
      if (driversData.length > 0 && driversData) {
        driversData = this.$jsonNullToStringV2(driversData);
        driversData = this.$deepTrimJsonV3(driversData);
        let driversArr = driversData.map(i => {
          i['Keyname'] = `${i['Staff_Name']} (${i['Staff_No']})`;
          return i;
        })
        this.drivers = driversArr;
        this.attendants = driversArr;
      }
    },
    getDestinations : async function () {
      let destinationData = await this.$apiCallV2(`/VehicleTracker/GetListMaster?master=destination&module=FMS`);
      if (destinationData.length > 0 && destinationData) {
        destinationData = this.$jsonNullToStringV2(destinationData)
        destinationData = this.$deepTrimJsonV3(destinationData);
        let destinationArr = destinationData.map(i => {
          i['Keyname'] = `${i['Destination Code']} ${(i['Area Name'] == '' ? '' : `(${i['Area Name']})`)}`
          return i;
        })
        this.destinations = destinationArr;

      }
    },
    contNoLostFocus: async function(state) {
      if(this.freeTextContainerNo != this.selectedContainerNo['Container #'] && !state){
        var response = await this.$showAlert(
          'warning',
          'Are you sure you want to update the container number?', 
          `You are about to change container number <b>${this.selectedContainerNo['Container #']}</b> to <b>${this.freeTextContainerNo}</b>.`, 
          [{"text" : "Confirm"},{"text" : "Cancel"}]
          );

        if (response === "Cancel") {  
          this.freeTextContainerNo = this.selectedContainerNo['Container #'];
        }
      }
    },
    populateFields: function(data) {
      if (data["PM"]) {
        this.selectedPrimeMover = this.primeMovers.find((primeMover) => {
          return primeMover["VehicleCode"].trim().toLowerCase() === data["PM"].trim().toLowerCase();
        });
      }

      if (data["Trailer"]) {
        this.selectedTrailerNo = this.trailers.find((trailer) => {
          return trailer["VehicleCode"].trim().toLowerCase() === data["Trailer"].trim().toLowerCase();
        });
      }

      if (data["Driver"]) {
        this.selectedDriver = this.drivers.find((driver) => {
          return driver["Staff_No"].trim().toLowerCase() === data["Driver"].trim().toLowerCase();
        });
      }

      if (data["Attendant"]) {
        this.selectedAttendant = this.attendants.find((attendant) => {
          return attendant["Staff_No"].trim().toLowerCase() === data["Attendant"].trim().toLowerCase();
        });
      }

      this.consignmentNoDisabled = this.tripIsBeingEdited;
      this.selectedConsignmentNo = this.consignments.find(i => {
        return i['Consignment #'] == data['Consignment #'];
      });

      if (!this.selectedConsignmentNo) {
        this.selectedConsignmentNo = null;
        this.selectedContainerNo = null;
      } else {
        this.selectedContainerNo = this.selectedConsignmentNo;
        this.freeTextConsignmentNo = this.selectedConsignmentNo['Consignment #'];
        this.freeTextContainerNo = this.selectedContainerNo['Container #'];
      }

      this.b2bConsignmentNoDisabled = this.tripIsBeingEdited;
      this.selectedB2BConsignmentNo = this.b2bConsignmentNo.find(i => {
        return i['Consignment #'] == data['B2B'];
      });

      if (!this.selectedB2BConsignmentNo) { // there is no b2b consignment
        this.selectedB2BConsignmentNo = null;
        this.selectedB2BContainerNo = null;

        // if the user is editing a trip and there is no b2b consignment, disable all b2b fields
        this.b2bContainerDisabled = this.tripIsBeingEdited;
        this.sealNoB2bDisabled = this.tripIsBeingEdited;
      } else {
        this.selectedB2BContainerNo = this.selectedB2BConsignmentNo;
        this.freeTextB2BConsignmentNo = this.selectedB2BConsignmentNo['Consignment #'];
        this.freeTextB2BContainerNo = this.selectedB2BContainerNo['Consignment #'];
      }

      // seal # population handled by selectedConsignmentNo and selectedB2BConsignmentNo watcher properties
      if (data["Movement"]) {
        this.selectedMovement = this.movements.find(i => {return i['MovementType'] === data["Movement"]}) || null;
      } else {
        this.selectedMovement = this.movements.find(i => {return i['IsNextMvt'] == '1'}) || null;
      }
      this.movementDropdownObjectSelected(this.selectedMovement);

      if (!this.tripIsBeingEdited) { // if user is assigning a new trip
        this.selectedETD = new Date(); // set ETD to current time
        let minutesToAdd = this.selectedMovement ? this.selectedMovement['TripDurationMin'] : 0; // set ETA to current time + minutesToAdd
        this.selectedETA = (minutesToAdd == 0 || minutesToAdd == '') ? new Date() : new Date(new Date().setTime(new Date().getTime() + (minutesToAdd * 60 * 1000)));
      } else { // user is editing a trip
        // populate ETD
        if (data["ETD Datetime"]) { // expected format from API: yyyy-MM-dd HHmm
          const [date, time] = data["ETD Datetime"].split(" ");
          const [year, month, day] = date.split("-")
          const hours = time.slice(0, 2);
          const minutes = time.slice(2, 4);

          this.selectedETD = new Date(year, month - 1, day, hours, minutes);
        } else {
          this.selectedETD = null;
        }

        // populate ETA
        if (data["ETA Datetime"]) { // expected format from API: yyyy-MM-dd HHmm
          const [date, time] = data["ETA Datetime"].split(" ");
          const [year, month, day] = date.split("-")
          const hours = time.slice(0, 2);
          const minutes = time.slice(2, 4);

          this.selectedETA = new Date(year, month - 1, day, hours, minutes);
        } else {
          this.selectedETA = null;
        }
      }

      if (data["Remarks"]) {
        this.inputRemarks = data["Remarks"].trim();
      }
    },
    consignmentDetails: function() {
      return [
        'consignmentNoDisabled',
        'containerDisabled',
        'sealNoDisabled',
        'b2bConsignmentNoDisabled',
        'b2bContainerDisabled', 
        'sealNoB2bDisabled',
        'movementDisabled',
        'fromDisabled',
        'toDisabled',
        'ETDDisabled', 
        'ETADisabled',
        'remarksDisabled'
      ];
    },
    mountedDisabled: function() {
      this.consignmentDetails().forEach(field => {
        this[field] = true;
      });
    }, 
    mountedEnabled: function() {
      this.consignmentDetails().forEach(field => {
        this[field] = false;
      });
    }, 
    disableFields: function() {
        const allFields = [
            ...this.consignmentDetails(),
            'primeMoverDisabled',
            'trailerNoDisabled', 
            'driverDisabled',
            'attendantDisabled',
        ];
        
        allFields.forEach(field => {
            this[field] = true;
        });
    },
    resetFields : function () {
      this.selectedPrimeMover = null;
      this.primeMoverDisabled = false;
      this.availabilityValue = '';
      this.availabilityValid = false;
      this.roadTaxValue = '';
      this.roadTaxValid = false;
      this.inspectionValue = '';
      this.inspectionValid = false;
      this.permitValue = '';
      this.permitValid = false;

      this.selectedTrailerNo = null;
      this.trailerNoDisabled = false;

      this.selectedDriver = null;
      this.driverDisabled = false;
      this.driverLicenseValue = '';
      this.driverLicenseValid = false;
      this.badgeDriverLicenseValue = '';
      this.badgeDriverLicenseValid = false;
      this.portPassDriverValue = '';
      this.portPassDriverValid = false;

      this.selectedAttendant = null;
      this.attendantLicenseValue = '';
      this.attendantLicenseValid = false;
      this.badgeAttendantLicenseValue = '';
      this.badgeAttendantLicenseValid = false;
      this.portPassAttendantValue = '';
      this.portPassAttendantValid = false;

      this.selectedConsignmentNo = null;
      this.freeTextConsignmentNo = '';
      this.consignmentNoDisabled = false;
      this.selectedContainerNo = null;
      this.freeTextContainerNo = '';
      this.containerDisabled = false;
      this.szType = '';
      this.hdg = '';
      this.del = '';
      this.inputSealNo = '';
      this.sealNoDisabled = false;

      this.selectedB2BConsignmentNo = null;
      this.freeTextB2BConsignmentNo = '';
      this.b2bConsignmentNoDisabled = false;
      this.selectedB2BContainerNo = null;
      this.freeTextB2BContainerNo = '';
      this.b2bContainerDisabled = false;
      this.szTypeB2b = '';
      this.hdgB2b = '';
      this.delB2b = '';
      this.inputSealNoB2b = '';
      this.sealNoB2bDisabled = false;

      this.selectedMovement = null;
      this.movementDisabled = false;
      this.selectedFrom = null;
      this.fromDisabled = false;
      this.selectedTo = null;
      this.toDisabled = false;
      this.selectedETD = new Date();
      this.ETDDisabled = false;
      this.selectedETA = new Date();
      this.ETADisabled = false;

      this.inputRemarks = '';
      this.remarksDisabled = false;

      this.disabledSave = false;
      this.postAssignMessage = [];
      this.errorMessageToDisplay = [];
      this.fieldsFulfilled = false;
      
      this.messageContainer.style.setProperty('background-color', 'white');
      this.messageContainer.style.setProperty('color', 'black');
    },
    //#region Message Container Events
    messageMouseOver: function() {
      let messageContainer = document.getElementsByClassName('message-container')[0];
      messageContainer.style.setProperty('position', 'absolute');
      messageContainer.style.setProperty('width', 'calc(100% - 10px)');
      messageContainer.style.setProperty('max-width', 'calc(100% - 10px)');
      messageContainer.style.setProperty('bottom', '5px');
      messageContainer.style.setProperty('left', '5px');
    },
    messageMouseOut: function() {
      let messageContainer = document.getElementsByClassName('message-container')[0];
      messageContainer.style.setProperty('position', '');
      messageContainer.style.setProperty('width', '');
      messageContainer.style.setProperty('max-width', '');
      messageContainer.style.setProperty('bottom', '');
      messageContainer.style.setProperty('left', '');
    },
    //#endregion
  },
  async mounted() {
    this.mountedDisabled();
    
    //group together for the 1st promise to populate lists
    const independentPromises = [
      this.getPrimeMovers(),
      this.getTrailers(),
      this.getDrivers(),
      this.getDestinations(),
    ];

    if (!this.assignData) {
      const total = independentPromises.length;
      let done = 0;
      //settle for 1st part 
      await Promise.allSettled(
        independentPromises.map(p => p.then(() => this.$topLoading(++done / total)))
      );
      this.$nextTick(() => {
        this.messageContainer = document.getElementsByClassName('message-container')[0];
      });
      return;
    }

    this.title = this.assignData['Bucket'] || this.assignData['Consignment #'];

    //group together for the 2nd promise to populate the get the details
    const dependentPromises = [
      this.getB2bConsignmentNo(this.assignData),
      this.getJobListing(this.assignData),
      this.getMovements(this.assignData),
    ];

    const allPromises = [...independentPromises, ...dependentPromises];
    const total = allPromises.length;
    let done = 0;

    //after fetch all the details settle promise
    await Promise.allSettled(
      allPromises.map(p => p.then(() => this.$topLoading(++done / total)))
    );
    
    this.populateFields(this.assignData);

    this.$nextTick(() => {
      this.messageContainer = document.getElementsByClassName('message-container')[0];
    })

    this.mountedEnabled();
  },
  watch: {
    assignData : {
      handler : async function(val) {
        if (!val) {
          return;
        } else {
          this.resetFields();
          this.mountedDisabled();
          this.title = val['Bucket'] || val['Consignment #']; // VehicleSchedule page does not have Bucket, display Consignment # instead
          await this.getB2bConsignmentNo(val);
          await this.getJobListing(val);
          await this.getMovements(val);
          if (!this.destinations || this.destinations.length === 0) {
            await this.getDestinations();
          }
          this.populateFields(val);
          this.mountedEnabled();
        }
      },deep : true
    },
    selectedPrimeMover : function (val) {
      if (val && Object.keys(val).length > 0) {
        this.availabilityValue = val['Availability'] == '1' ? 'Yes' : 'No'
        this.availabilityValid = val['Availability'] == '1';
        this.roadTaxValue = val['RoadTaxExpiryDate'];
        this.roadTaxValid = (val['RoadTaxExpiryDate'] == '') ? false : val['RoadTaxExpiryDate'].toDate() >= Date.now();
        this.inspectionValue = val['InspectionDate'];
        this.inspectionValid = (val['InspectionDate'] == '') ? false : val['InspectionDate'].toDate() >= Date.now();
        this.permitValue = val['PermitExpiryDate'];
        this.permitValid = (val['PermitExpiryDate'] == '') ? false : val['PermitExpiryDate'].toDate() >= Date.now();
      }
    },
    selectedDriver : function (val) {
      if (val) {
        this.driverLicenseValue = val['DrvLicenseExpiryDate']
        this.driverLicenseValid = (val['DrvLicenseExpiryDate'] == '') ? false : val['DrvLicenseExpiryDate'].toDate() >= Date.now();
        this.badgeDriverLicenseValue = val['BadgeLicenseExpiryDate']
        this.badgeDriverLicenseValid = (val['BadgeLicenseExpiryDate'] == '') ? false : val['BadgeLicenseExpiryDate'].toDate() >= Date.now();
        this.portPassDriverValue = val['PortPassExpiryDate']
        this.portPassDriverValid = (val['PortPassExpiryDate'] == '') ? false : val['PortPassExpiryDate'].toDate() >= Date.now();
      }
    },
    selectedAttendant : function (val) {
      if (val) {
        this.attendantLicenseValue = val['DrvLicenseExpiryDate']
        this.attendantLicenseValid = (val['DrvLicenseExpiryDate'] == '') ? false : val['DrvLicenseExpiryDate'].toDate() >= Date.now();
        this.badgeAttendantLicenseValue = val['BadgeLicenseExpiryDate']
        this.badgeAttendantLicenseValid = (val['BadgeLicenseExpiryDate'] == '') ? false : val['BadgeLicenseExpiryDate'].toDate() >= Date.now();
        this.portPassAttendantValue = val['PortPassExpiryDate']
        this.portPassAttendantValid = (val['PortPassExpiryDate'] == '') ? false : val['PortPassExpiryDate'].toDate() >= Date.now();
      }
    },
    selectedConsignmentNo : function (val) {
      if (val) { // if a consignment was selected from the dropdown
        this.selectedContainerNo = val;
        this.freeTextContainerNo = val['Container #'];
        this.szType = (val['Sz/Ty'] === '') ? '-' : val['Sz/Ty']
        this.hdg = (val['Hdg'] === '') ? '-' : val['Hdg']
        this.del = (val['Del'] === '') ? '-' : val['Del']
        this.inputSealNo = val["Seal #"] || "";
      } else {
        this.selectedContainerNo = null;
        this.szType = '-';
        this.hdg = '-';
        this.del = '-';
        this.inputSealNo = "";
      }
    },
    selectedB2BConsignmentNo : function (val) {
      if (val) {
        this.selectedB2BContainerNo = val;
        this.freeTextB2BContainerNo = val['Container #'];
        this.szTypeB2b = (val['SzType'] === '') ? '-' : val['SzType'];
        this.hdgB2b = (val['Handling Type'] === '') ? '-' : val['Handling Type'];
        this.delB2b = (val['Delivery Type'] === '') ? '-' : val['Delivery Type'];
        this.inputSealNoB2b = val['Seal #'];
        this.sealNoB2bDisabled = (
          this.tripIsBeingEdited ? // if trip is being edited
          val['Consignment #'] === '' : // disable if b2b consignment # is blank
          false // else, don't disable
        );
      } else {
        this.selectedB2BContainerNo = null;
        this.b2bContainerDisabled = this.tripIsBeingEdited; // if a trip is being edited and b2b consignment # is null, disable the b2b container # field
        this.szTypeB2b = '-';
        this.hdgB2b = '-';
        this.delB2b = '-';
        this.inputSealNoB2b = '';
        this.sealNoB2bDisabled = this.tripIsBeingEdited; // if a trip is being edited and b2b consignment # is null, disable the b2b seal no field
      }
    },
    freeTextConsignmentNo : function (newVal, oldVal) {
      if (this.selectedConsignmentNo && this.selectedConsignmentNo['Consignment #'] !== newVal) {
        this.selectedContainerNo = null;
        this.containerDisabled = false;
        this.szType = '-';
        this.hdg = '-';
        this.del = '-';
        this.inputSealNo = "";
      }
    },
    freeTextB2BConsignmentNo : function (newVal, oldVal) {
      if (this.selectedB2BConsignmentNo && this.selectedB2BConsignmentNo['Consignment #'] !== newVal) {
        this.selectedB2BContainerNo = null;
        this.b2bContainerDisabled = false;
        this.szTypeB2b = '-';
        this.hdgB2b = '-';
        this.delB2b = '-';
        this.inputSealNoB2b = '';
      }
    },
    fieldsFulfilled : function (val) {
      let messageContainer = document.getElementsByClassName('message-container')[0];

      if (val) {
        messageContainer.addEventListener('mouseover', this.messageMouseOver);
        messageContainer.addEventListener('mouseout', this.messageMouseOut);
      } else {
        messageContainer.removeEventListener('mouseover', this.messageMouseOver);
        messageContainer.removeEventListener('mouseout', this.messageMouseOut);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

$assignBg: rgb(235, 235, 255);
$assignSection : #535cda;
$brParent : 10px;
$brChild : 5px;

.assign-main {
  background-color: $assignBg;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius : $brParent;

  > .assign-header {
    height: fit-content;
    width: 100%;
    background-color: $assignSection;
    color: white;
    border-radius: $brChild;
    padding: 5px;

    > .label-container {
      display : flex;
      position: relative;
      font-size: 1.1rem;

      > img {
        position: absolute;
        top: 1px;
        right: 5px;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }

      > .label-title {
        width: fit-content;
      }
      > .label-seperator {
        padding: 0px 5px;
      }
      > .label-content {
        font-weight: bold;
      }
    }
  }
  > .assign-content {
    display: flex;
    flex-direction: column;
    overflow: auto;
    width: 100%;
    height: 100%;

    > .white-container {
      background-color: white;
      width: calc(100% - 10px);
      height: fit-content;
      border-radius: 5px;
      border: 1px solid gray;
      margin-top : 5px;
      margin-left: 5px;
      margin-right: 5px;
      padding: 5px;

      > .content-label {
        width: 100%;
        height: fit-content;
        display: flex;
        margin-bottom: 5px;

        > .content {
          width: 100%;
          flex : 1;

          > .content-container {
            padding :5px;
            border : 1px solid gray;
            border-radius: 5px;

            > .content-container-row {
              display: flex;
              > .content-container-title {
                min-width: 36px;
                max-width: 36px;
              }

              > .content-container-separator {
                padding-left :5px;
                padding-right: 5px;
              }

              > .content-container-value {
                font-weight: bold;
              }

            }
          }


        }
        > :nth-last-child(1) {
          margin-left: 5px;
        }
      }
    }
    > :nth-last-child(1) {
      margin-bottom: 5px;
    }
  }
  > .assign-footer {
    width: 100%;
    background-color: $assignSection;
    height: 100px;
    border-radius: $brChild;
    display: flex;
    align-items: center;
    padding: 5px;
    position: relative;
    transition: 0.3s;
    min-height: 100px;
    justify-content: flex-end;

    > * {
      border-radius: 2.5px;
      background-color: white;
      width: 100%;
      height: 100%;
    }

    > .message-container {
      flex: 2;
      overflow: auto;
      padding: 5px;
      transition: 0.3s;
      position: absolute;
      left: 5px;
      bottom: 5px;
      max-height: calc(100% - 10px);
      height: 100%;
      max-width: calc(100% - 110px);
      width: 100%;
      z-index: 99;

      > * > * {
        >a {
          /* color: black; */
          cursor: pointer;
          padding: 2px;
          text-decoration: underline;
          color: blue;
        }
        a:hover {
          text-decoration: underline;
          background-color: yellow;
        }

        a:active {
          text-decoration: underline;
          background-color: royalblue;
        }

      }
    }
    > .buttons-container {
      flex: 1;
      display: flex;
      min-width: 100px;
      max-width: 100px;
      justify-content: space-around;
      /* align-items: space-around; */
      flex-direction: column;
      background-color: $assignSection;

      > *{
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-align: center;
        margin-left: 5px;

        >img {
          height: 25px;
          width: 25px;
          margin-right: 5px;
        }
      }
    }
  }
  .movement-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

</style>